<span class="prama-badge"><i *ngIf="canRemove" class="fa fa-times icon-btn" (click)="this.remove()"></i> {{ tag.name }}</span>
